import React, { useEffect, useState } from "react";
import "../../global.css";
import "./auditoryNarratives.css";
import { useMediaQuery } from "react-responsive";
import { setContent, setIsOpenContentsModal } from "../../redux/contentSlice";
import { useSelector, useDispatch } from "react-redux";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import { FaArrowRight } from "react-icons/fa";
import DetailsModal from "../../components/detailsmodal/DetailsModal";
import { useTranslate } from "../../utils/useTranslate";

const AuditoryNarratives = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { language } = useSelector((state) => state.language);

  const [isShowAll, setIsShowAll] = useState(false);

  const [contents, setContents] = useState([]);
  const [otherContents, setOtherContents] = useState([]);

  const [contentDatas, setContentDatas] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState(null);

  const [isShowAuditory, setIsShowAuditory] = useState(null);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  const { content, isOpenContentsModal } = useSelector(
    (state) => state.content
  );

  useEffect(() => {
    dispatch(setContent(contents[1]));
    setOtherContents(contents.filter((x) => x.id !== Number(contents[1].id)));
    setContentDatas(contents[1]?.datas);
  }, [contents, dispatch]);

  return (
    <div className="globalContainer auditoryNarrativesContainer">
      <div
        className="auditoryNarrativesLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
      >
        <div className="auditoryNarrativesLeftSubContainer">
          <div className="auditoryNarrativesLeftSubAltContainer">
            <span className="textFlex auditoryNarrativesTitleStyle">
              {language.value === "tr"
                ? content?.title.toLocaleUpperCase("tr-TR")
                : content?.title.toLocaleUpperCase("en-US")}
            </span>
            <span className="textMono auditoryNarrativesSubTitleStyle">
              {content?.subTitle}
            </span>
          </div>
          <span className="textFlex auditoryNarrativesDescriptionStyle">
            {content?.description}
          </span>
        </div>
        {isShowAll === true && (
          <div
            style={{
              width: "100%",
              height: "35px",
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <button
              className="textMono"
              style={{
                padding: "5px 20px",
                backgroundColor: "#ef4536",
                fontWeight: "bold",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                setContentDatas(content?.datas);
                setIsShowAll(false);
              }}
            >
              {language.value === "tr"
                ? translate("showAll").toLocaleUpperCase("tr-TR")
                : translate("showAll").toLocaleUpperCase("en-US")}
            </button>
          </div>
        )}
        <div className="auditoryNarrativesLeftBottomContainer">
          {contentDatas?.map((item, index) => (
            <div
              key={item.id}
              style={{
                width: isMobile === false ? "97%" : "100%",
                borderRadius: "8px",
                display: "flex",
                padding: isMobile === false && "10px",
                flexDirection: "column",
                border: isMobile === false && "1px solid #100F0D",
                gap: "20px",
                backgroundColor: isMobile === false && "#ffffff",
              }}
            >
              {isShowAuditory === item.id ? (
                <>
                  <img
                    style={{
                      width: "100%",
                      height: isMobile === false ? "40vh" : "30vh",
                      maxHeight: "370px",
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                    alt=""
                    src={`/assets/images/${item?.image}`}
                    onClick={() => {
                      setIsShowAuditory(!item.id);
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      height: "52px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <span
                      className="textFlex"
                      style={{
                        fontSize: "20px",
                        color: "#100F0D",
                        fontWeight: "600",
                      }}
                    >
                      {language.value === "tr"
                        ? item?.title.toLocaleUpperCase("tr-TR")
                        : item?.title.toLocaleUpperCase("en-US")}
                    </span>
                    <button
                      style={{
                        backgroundColor:
                          item?.tagColor === ""
                            ? "#fffff"
                            : `${item?.tagColor}`,
                        display: "inline-block",
                        borderRadius: "3px",
                        padding: "2px 4px",
                        border: "1px solid #100F0D",
                        width: "fit-content",
                        maxWidth: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const newDatas = content?.datas.filter(
                          (x) => x.tagName === item.tagName
                        );
                        setContentDatas(newDatas);
                        setIsShowAll(true);
                      }}
                    >
                      <span
                        className="textMono"
                        style={{
                          fontSize: "12px",
                          color: "#100F0D",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                        }}
                      >
                        {language.value === "tr"
                          ? item?.tagName.toLocaleUpperCase("tr-TR")
                          : item?.tagName.toLocaleUpperCase("en-US")}
                      </span>
                    </button>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <span
                      className="textMono"
                      style={{
                        fontSize: "14px",
                        color: "#100F0D",
                        fontWeight: "bold",
                      }}
                    >
                      {language.value === "tr"
                        ? item?.creditsLabel.toLocaleUpperCase("tr-TR")
                        : item?.creditsLabel.toLocaleUpperCase("en-US")}
                    </span>
                    <span
                      className="textMono"
                      style={{
                        fontSize: "14px",
                        color: "#100F0D",
                        fontWeight: "400",
                      }}
                    >
                      {language.value === "tr"
                        ? item?.creditsName.toLocaleUpperCase("tr-TR")
                        : item?.creditsName.toLocaleUpperCase("en-US")}
                    </span>
                    <span
                      className="textMono"
                      style={{
                        fontSize: "14px",
                        color: "#100F0D",
                        fontWeight: "bold",
                      }}
                    >
                      {language.value === "tr"
                        ? translate("programmingLanguage").toLocaleUpperCase(
                            "tr-TR"
                          )
                        : translate("programmingLanguage").toLocaleUpperCase(
                            "en-US"
                          )}
                      :
                    </span>
                    <span
                      className="textMono"
                      style={{
                        fontSize: "14px",
                        color: "#100F0D",
                        fontWeight: "400",
                      }}
                    >
                      {language.value === "tr"
                        ? item?.programmingLanguage.toLocaleUpperCase("tr-TR")
                        : item?.programmingLanguage.toLocaleUpperCase("en-US")}
                    </span>
                  </div>
                  <span
                    className="textFlex"
                    style={{
                      width: "100%",
                      fontSize: "12px",
                      color: "#100F0D",
                      fontWeight: "400",
                      maxWidth: "440px",
                      lineHeight: "140%",
                    }}
                  >
                    {item?.description}
                  </span>
                  <hr
                    style={{
                      border: "1px solid #100F0D80",
                      width: isMobile === false ? "calc(100% + 19px)" : "98%",
                      marginLeft: isMobile === false && "-10px",
                      marginRight: isMobile === false && "-10px",
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: isMobile === false ? "row" : "column",
                      minHeight: "35px",
                    }}
                  >
                    <div
                      style={{
                        width: isMobile === false ? "60%" : "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                      }}
                    >
                      {item?.spotifyLink !== "" &&
                        item?.spotifyLink !== undefined && (
                          <img
                            style={{ cursor: "pointer" }}
                            alt=""
                            src={`/assets/images/spotify.png`}
                            onClick={() => {
                              window.open(
                                item.spotifyLink,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          />
                        )}
                      {item?.applePodcastLink !== "" &&
                        item?.applePodcastLink !== undefined && (
                          <img
                            style={{ cursor: "pointer" }}
                            alt=""
                            src={`/assets/images/applePodcast.png`}
                            onClick={() => {
                              window.open(
                                item.applePodcastLink,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          />
                        )}
                    </div>
                    <div
                      style={{
                        width: isMobile === false ? "40%" : "100%",
                        height: "35px",
                        display: "flex",
                        justifyContent:
                          isMobile === false ? "flex-end" : "flex-start",
                        alignItems: "center",
                        marginTop:
                          isMobile === true &&
                          item?.fileName !== undefined &&
                          "30px",
                        borderRadius: "3px",
                        marginBottom:
                          isMobile === true &&
                          item?.fileName !== undefined &&
                          "30px",
                      }}
                    >
                      {item?.fileName !== undefined && (
                        <>
                          <button
                            style={{
                              width: isMobile === false ? "80%" : "40%",
                              height: "100%",
                              backgroundColor: "#F2F2F2",
                              borderRadius: "3px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => setSelectedFileName(item.fileName)}
                          >
                            <span
                              className="textMono"
                              style={{
                                color: "#100F0D",
                                fontSize: "16px",
                                fontWeight: "bold",
                                width: "90%",
                                lineHeight: "90%",
                              }}
                            >
                              {language.value === "tr"
                                ? translate("goDetails").toLocaleUpperCase(
                                    "tr-TR"
                                  )
                                : translate("goDetails").toLocaleUpperCase(
                                    "en-US"
                                  )}
                            </span>
                            <FaArrowRight
                              style={{
                                width: "9px",
                                height: "9px",
                              }}
                            />
                          </button>
                          {selectedFileName === item.fileName && (
                            <DetailsModal
                              isOpen={true}
                              onClose={() => setSelectedFileName(null)}
                              fileName={item.fileName}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div
                  key={item.id}
                  style={{
                    width: "100%",
                    height: isMobile === false ? "40vh" : "30vh",
                    maxHeight: "370px",
                    backgroundColor: "black",
                    borderRadius: "8px",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                    alt=""
                    src={`/assets/images/${item?.image}`}
                    onClick={() => setIsShowAuditory(item.id)}
                  />
                  <div
                    style={{
                      position: "absolute",
                      display: "flex",
                      flexDirection: "column",
                      width: "90%",
                      height: "72px",
                      bottom: "20px",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsShowAuditory(item.id)}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="textFlex"
                        style={{
                          color:
                            isShowAuditory === item.id ? "#EF4536" : "#F2EDED",
                          fontSize: "20px",
                          fontWeight: "600px",
                          textShadow:
                            "1px 1px 0px black, -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black",
                        }}
                      >
                        {language.value === "tr"
                          ? item?.title.toLocaleUpperCase("tr-TR")
                          : item?.title.toLocaleUpperCase("en-US")}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <button
                        style={{
                          height: "24px",
                          borderRadius: "3px",
                          border: "1px solid #100F0D",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const newDatas = content?.datas.filter(
                            (x) => x.tagName === item.tagName
                          );
                          setContentDatas(newDatas);
                          setIsShowAll(true);
                        }}
                      >
                        <span
                          className="textMono"
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {language.value === "tr"
                            ? item?.tagName.toLocaleUpperCase("tr-TR")
                            : item?.tagName.toLocaleUpperCase("en-US")}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="auditoryNarrativesRightContainer">
          <div className="auditoryNarrativesRightSubContainer">
            <span className="textMono otherContentTextStyle">
              {language.value === "tr"
                ? translate("otherContents").toLocaleUpperCase("tr-TR")
                : translate("otherContents").toLocaleUpperCase("en-US")}
            </span>
            <hr className="auditoryNarrativesRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              gap: "10px",
            }}
          >
            {otherContents.map((item) => (
              <ContentCard
                item={item}
                isHome={false}
                isMobile={false}
                key={item.id}
              />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenContentsModal === false ? (
        <div className="homeRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => dispatch(setIsOpenContentsModal(true))}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("otherContents").toLocaleUpperCase("tr-TR")
                  : translate("otherContents").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true &&
        isOpenContentsModal === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="homeRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="homeRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("otherContents").toLocaleUpperCase("tr-TR")
                      : translate("otherContents").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="homeRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {otherContents.map((item) => (
                    <ContentCard
                      item={item}
                      key={item.id}
                      isHome={false}
                      isMobile={true}
                    />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => dispatch(setIsOpenContentsModal(false))}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("otherContents").toLocaleUpperCase("tr-TR")
                        : translate("otherContents").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default AuditoryNarratives;
